// ConvoCX app shell — routed pages (CON-853).
// Maps hash routes to page components. Inbox is the real three-pane
// workspace; the rest are FR-12.5 stubs wired for navigation.

import type { ComponentType } from 'react';
import { InboxPage, type InboxPageProps } from '../../inbox/InboxPage';
import { StubPage } from './StubPage';

export interface RoutedPageProps {
  mode: 'dark' | 'light';
  onToggleMode: () => void;
}

type PageMap = Record<string, ComponentType<RoutedPageProps>>;

function stubPage(title: string, description: string, note?: string): ComponentType<RoutedPageProps> {
  return () => <StubPage title={title} description={description} note={note} />;
}

export const PAGES: PageMap = {
  inbox: (props: RoutedPageProps) => <InboxPage {...(props as InboxPageProps)} />,
  contacts: stubPage(
    'Contacts & CRM',
    'People, organisations and deal context across every channel.',
    'Contact list and CRM pipeline are in a later phase.',
  ),
  teams: stubPage('Teams', 'Manage your support team, roles and routing.'),
  reports: stubPage('Reports', 'First response, resolution, volume and CSAT analytics.'),
  templates: stubPage('Message Templates', 'Canned responses and message templates for consistent replies.'),
  canned: stubPage('Canned Responses', 'Saved replies your team can drop into any conversation.'),
  channels: stubPage('Channels', 'Connect WhatsApp, Messenger, Instagram, email, SMS and web chat.'),
  labels: stubPage('Tags & Labels', 'Organise conversations with tags and labels.'),
  knowledge: stubPage('Knowledge Base', 'Shared answers and help-centre content.'),
  csat: stubPage('CSAT', 'Customer satisfaction surveys and feedback.'),
  notifications: stubPage('Notifications', 'Activity across your workspace.'),
  help: stubPage('Help Centre', 'Guides and support resources.'),
  settings: stubPage('Settings', 'Profile, security, business hours, SLA and AI preferences.'),
  billing: stubPage('Billing', 'Plans, currency and payment methods.'),
};

export function pageFor(name: string): ComponentType<RoutedPageProps> {
  return PAGES[name] ?? PAGES.inbox;
}